import React from 'react';
import { motion } from 'framer-motion';
import Button from '@/components/CommonComponent/button'
import Link from 'next/link'
import styled from 'styled-components';
const PricingTable = ({ props }: any) => {
  // Extract pricing card titles dynamically
  // console.log('props are ,',props)
  const getPricingCardTitles = (props: any) => {
    if (!Array.isArray(props)) return []; // If props is undefined or not an array, return an empty array

    return props.flatMap((pkg: any) =>
        pkg?.pricing_features?.flatMap((feature: any) =>
            feature?.pricing_cards?.map((card: any) => card.title) || []
        ) || []
    );
};

const pricingCardTitles = getPricingCardTitles(props);
const uniqueValues = Array.from(new Map(pricingCardTitles?.map((title: any) => [title, title])).keys());

  return (
    <div className='bg-grey'>
      <div className="py-16 px-4 2xl:px-6 text-homegrey 2xl:w-[80%] mx-auto">
        <h2 className='text-center font-bold text-[20px] text-homeblack leading-[45px]'>
          {props[0]?.title}
        </h2>
        <div>

        </div>  
        {/* <div dangerouslySetInnerHTML={{ __html: props[0]?.description }} /> */}
        <div  className="overflow-x-auto p-3 mt-10 bg-white rounded-3xl">
          <table className="w-full rounded-b-2xl min-w-[800px]">
            <thead>
              <tr className="bg-blue text-[18px] text-left text-white">
                {/* Table Title */}
                <th className="px-4 rounded-tl-3xl border-r-[2px] border-white py-6">
                  {props[0]?.table_title}
                </th>
                {/* Dynamic Headers */}
                {uniqueValues?.map((elem: any, index: number) => (
                  <th key={index} className="px-6 capitalize text-left border-r-[2px] border-white py-6">
                    {elem.replace(/_/g, ' ')}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {props?.map((packageItem: any, packageIndex: any) =>
                packageItem?.pricing_features.map((feature: any, index: number) => {
                  return (
                    <motion.tr
                      key={feature.id}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: (packageIndex + index) * 0.1, duration: 0.5 }}
                      className={`${index % 2 === 0 ? 'bg-white' : 'bg-grey'}`}
                    >
                      {/* Feature Title */}
                      <td className="px-4 py-6 border-x-[2px] border-textgrey text-homeblack text-[18px]">
                        {feature.title}
                      </td>
                      {/* Dynamic Feature Data based on uniqueValues */}
                      {uniqueValues?.map((category: any, catIndex: number) => {
                        const matchingCard = feature?.pricing_cards?.find((card: any) => card.title === category);
                        return matchingCard?.content ? (
                            <td
                              key={catIndex}
                              className="px-4 py-6 border-r-[2px] border-textgrey text-homegrey text-[17px]"
                              dangerouslySetInnerHTML={{ __html: matchingCard.content }}
                            />
                          ) : (
                            <td key={catIndex} className="px-4 py-6 border-r-[2px] border-textgrey text-homegrey text-[17px]">
                                <Link href={`/${matchingCard?.link_url}`}>
                              <Button content={matchingCard?.link_text} />
                                </Link>
                            </td>
                          );
                          
                      })}
                    </motion.tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <Wrapper>
            <div className='text-center mt-10 text-homeblack' dangerouslySetInnerHTML={{ __html: props[0]?.description }} />
          </Wrapper>
          <div className='mx-auto flex justify-center'>
            <Link href={"/get-a-free-quote"}>
            <Button content={"Get A Proposal Now"} />
          </Link>
          </div>
      </div>
    </div>
  );
};

export default PricingTable;


const Wrapper = styled.div`
a{
  color:white;
  background-color:var(--pink);
  padding:10px 20px; 
  margin-left:10px;
  border-radius:20px;
  border:2px solid var(--pink);
  
  }

  a:hover{
    background-color:var(--white);
    color:var(--pink);
    border:2px solid var(--pink);
transition:2s eas-in-out !important
    }

`;